exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".favorite-operation[data-v-2f99ff32]{padding-top:.1rem;padding-bottom:.1rem}@media (max-width:991px){.favorite-operation[data-v-2f99ff32]{padding-top:.4rem;padding-bottom:.4rem}}.photo-cell[data-v-2f99ff32]{margin-bottom:2px}.photo-cell .photo-cell-inner[data-v-2f99ff32]{background-color:#fff;border:2px solid #a8a5a3;border-radius:.5rem}.photo-cell .photo-cell-inner.favorite[data-v-2f99ff32]{border:2px solid #ec5c45}.photo-cell .photo-cell-inner .favorite-operation[data-v-2f99ff32],.photo-cell .photo-cell-inner .photo-no[data-v-2f99ff32]{font-size:.8rem}.photo-cell .photo-cell-inner .image-zoom-btn[data-v-2f99ff32]{font-size:1.2rem;color:#82ba1d;cursor:pointer;position:absolute;right:5px;top:50%;transform:translateY(-50%) translateX(0)}@media (max-width:991px){.photo-cell .photo-cell-inner .image-zoom-btn[data-v-2f99ff32]{font-size:2rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-2f99ff32&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/page/partials/Order/Catalog/SnapHorizonPhoto.vue
// module id = 499
// module chunks = 0